var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-section mb-2"},[_c('div',{staticClass:"header-add",domProps:{"innerHTML":_vm._s(_vm.settings.banner_728_90_footer)}}),_c('div',{staticClass:"Footer"},[[_c(_vm.attributes.theme,{key:_vm.attributes.theme,tag:"component",attrs:{"attributes":_vm.attributes,"footerMenu":_vm.footerMenu,"settings":_vm.settings}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }